export default __webpack_public_path__ + "static/media/error.ccecb251.svg";